import axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage';

// API Base URL
export const API_URL = 'https://ilkaykids.com/api';
//export const API_URL = 'http://localhost:5001/api';

// Axios instance oluşturma
const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Request interceptor - Her istekte token'ı ekle
axiosInstance.interceptors.request.use(
  async (config) => {
    try {
      const token = await AsyncStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      console.error('AsyncStorage token hatası:', error);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Hata yönetimi
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    
    // Eğer 401 hatası alırsak ve bu tekrar deneme yapılmamış bir istekse
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      try {
        // Token yenileme işlemi burada yapılabilir
        // const refreshToken = await AsyncStorage.getItem('refreshToken');
        // const response = await axios.post(`${API_URL}/auth/refresh-token`, { refreshToken });
        // const newToken = response.data.token;
        // await AsyncStorage.setItem('token', newToken);
        // originalRequest.headers.Authorization = `Bearer ${newToken}`;
        // return axiosInstance(originalRequest);
        
        // Şimdilik token yenileme olmadığı için kullanıcıyı çıkış yaptıralım
        await AsyncStorage.removeItem('token');
        await AsyncStorage.removeItem('user');
        
        // Uygulama yeniden başlatma veya login sayfasına yönlendirme işlemi burada yapılmalı
        // Bu client-side işlem olduğu için gerçek uygulamada, 
        // bu mantık AuthContext içinde de ele alınabilir
      } catch (refreshError) {
        console.error('Token yenileme hatası:', refreshError);
        // Yenileme hatası durumunda kullanıcıyı çıkış yaptır
        await AsyncStorage.removeItem('token');
        await AsyncStorage.removeItem('user');
      }
    }
    
    return Promise.reject(error);
  }
);

// Geriye uyumluluk için API_BASE_URL'i de export edelim
export const API_BASE_URL = API_URL;

export default axiosInstance;
